import { loginRequest } from "../authConfig";

export const fetchAuthorized = async (instance, url, options = {}, ) => {
    try {
        const accounts = instance.getAllAccounts();
        if(accounts.length === 0)
            instance.loginRedirect(loginRequest);

        const tokenResponse = await instance.acquireTokenSilent({
            account: accounts[0], // First account
            scopes: loginRequest.scopes,
        });

        const headers = {
            ...options.headers,
            Authorization: `Bearer ${tokenResponse.accessToken}`
        }
        const opts = { ...options, headers };

        const response = await fetch(url, opts);

        if (response.status === 401)
            instance.loginRedirect(loginRequest);

        return response;
    } catch (error) {
        console.error("Error acquiring token: ", error);
        throw error;
    }
};